
import MoreVertical from "../../../assets/outline/MoreVertical.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoreVerticalIcon({ className, dataTestid = "MoreVerticalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoreVertical data-testid={dataTestid} className={classes} {...rest} />
  );
}
